import makeStyles from '@mui/styles/makeStyles';

const getColor = theme => ({ profile }) => {
  if (profile === 'always_online') {
    return theme.palette.indicator.green
  }

  if (profile === 'always_offline') {
    return theme.palette.indicator.red
  }

  return theme.palette.secondary.main
}

const useStyles = makeStyles(theme => ({
  root: {
    color: getColor(theme),
    cursor: 'default'
  }
}))

export default useStyles
